export default "__VITE_ASSET__dkUdQ8LD__"